import type { JSX } from 'react'
import type { INotificationToast } from './NotificationToast.h'

import { ButtonColors, ButtonIconSizes, IconPositions } from 'atoms/Button'
import { Icon, IconNames, IconSizes } from 'atoms/Icon'
import { TextBox, TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { COLOR } from 'vars/color'
import { NotificationToastType } from './NotificationToast.h'
import {
  CloseButtonSC,
  NotificationToastIconSC,
  NotificationToastMessageSC,
  NotificationToastSC,
} from './NotificationToast.styled'

export interface INotificationToastProps extends INotificationToast {
  onClose: () => void
}

const getIconByType = (type?: NotificationToastType): IconNames => {
  switch (type) {
    case NotificationToastType.ERROR:
      return IconNames.info
    case NotificationToastType.WARNING:
      return IconNames.info
    case NotificationToastType.SUCCESS:
      return IconNames.check
    default:
      return IconNames.info
  }
}

const getIconColorByType = (type?: NotificationToastType): COLOR => {
  switch (type) {
    case NotificationToastType.ERROR:
      return COLOR.ADDITIONAL_RED
  }
  return COLOR.TEXT_ICON_CONSTANT_DARK
}

export const NotificationToast = ({
  message,
  type = NotificationToastType.INFO,
  icon,
  onClose,
}: INotificationToastProps): JSX.Element => {
  const iconName = icon || getIconByType(type)
  const iconColor = getIconColorByType(type)

  return (
    <NotificationToastSC>
      <NotificationToastIconSC>
        <Icon name={iconName} size={IconSizes.xSm} color={iconColor} />
      </NotificationToastIconSC>

      <NotificationToastMessageSC>
        <TextBox
          title={message}
          color={TextBoxColors.TEXT_ICON_CONSTANT_DARK}
          font={TextBoxTypes.FontMdToSm}
        />
      </NotificationToastMessageSC>

      <CloseButtonSC
        icon={IconNames.close}
        iconSize={ButtonIconSizes.small}
        colorDefault={ButtonColors.COLOR_SECONDARY}
        onClick={onClose}
        iconPosition={IconPositions.Center}
      />
    </NotificationToastSC>
  )
}
